import { makeStyles } from '@material-ui/core';
import { CheckmarkFilled, CheckmarkFilledError } from '@carbon/icons-react';
import { colorSet } from '@components/Provider';

interface PurchaseOrderBadgeProps {
  visible: boolean;
  isOnProcess: boolean;
}

/**
 * It returns a div with a circle class and a checkmark or error icon inside
 * @param - `visible` - boolean, whether to show the badge or not
 * @param - `isOnProcess` - boolean, if process is stopped by any reason it goes false.
 * @returns A function component that returns a div with a circle class.
 */
const PurchaseOrderBadge: React.FunctionComponent<PurchaseOrderBadgeProps> = ({
  visible,
  isOnProcess
}) => {
  const { circle } = useStyles();

  if (!visible) return null;
  return (
    <div className={circle}>
      {isOnProcess && <CheckmarkFilled color={colorSet.primary500} size={16} />}
      {!isOnProcess && (
        <CheckmarkFilledError color={colorSet.errorMain} size={16} />
      )}
    </div>
  );
};

export default PurchaseOrderBadge;

const useStyles = makeStyles(() => ({
  circle: {
    position: 'absolute',
    backgroundColor: colorSet.gray000,
    top: 7,
    left: 8,
    width: 24,
    height: 24,
    minWidth: 24,
    minHeight: 24,
    borderRadius: '50%',
    padding: 4,
    zIndex: 2
  }
}));
